import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const FrameDepth = ({ value, onChange, id = 'FrameDepth', label = 'Frame Depth', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const options = [
        { id: 1, value: '4.5',  label: '4 1/2"' },
        { id: 2, value: '3.25', label: '3 1/4"' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedValue(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (options.length > 0 && !selectedValue) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedValue(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedValue(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedValue}
                onChange={handleChange}
            >
                {options.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedValue === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FrameDepth;
